class Map
	constructor: () ->
		@params = window.MapData
		@map = null
		@map_container = $('#map').parent()
		@gmarkers = []
		console.log @
		switch @params.type
			when 'yandex'
				@initYandex()
			when 'google'
				@initGoogle()
			# else
			# 	@initYandex()
		return @
	initYandex: () ->
		M = @
		if typeof yandex != 'undefined'
			yandex.ready(@buildYandex)
		else
			setTimeout () ->
				M.initYandex()
			, 100
	## ## ##
	initGoogle: () ->
		M = @
		if typeof google != 'undefined'
			@buildGoogle()
		else
			setTimeout () ->
				M.initGoogle()
			, 100
	## ## ##
	buildYandex: () ->
		M = window.jsmap
		center = M.params.center.split(/\s*,\s*/)
		center = [parseFloat(center[0]), parseFloat(center[1])]
		mapOptions =
			zoom: parseFloat(M.params.zoom)
			center: center
			controls: []

		M.map = new yandex.Map(document.getElementById('map'), mapOptions)
		M.map.behaviors.disable('scrollZoom')
		M.map.controls.add('zoomControl', {
			size: 'large'
		})
		M.parseMarkersYandex()
		$('body').on 'click', '[data-action="full-map"]', () ->
			M.fullSizeYandex()
		return
	buildGoogle: () ->
		M = @
		center = M.params.center.split(/\s*,\s*/)
		center = { 'lat': parseFloat(center[0]), 'lng': parseFloat(center[1]) }
		mapOptions =
			zoom: parseFloat(M.params.zoom)
			center: center
			disableDefaultUI: true
			scrollwheel: false
			zoomControl: true
			scaleControl: false
			mapTypeId: 'roadmap'
			# styles: [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}]
		M.map = new google.maps.Map(document.getElementById('map'), mapOptions)
		M.parseMarkersGoogle()
	## ## ##
	parseMarkersYandex: () ->
		M = @
		for index,mark of M.params.markers
			if mark.type == 'Point'
				M.appendYandexMarker(mark)
			if mark.type == 'Circle'
				M.appendYandexCircle(mark)
	parseMarkersGoogle: () ->
		M = @
		for index,mark of M.params.markers
			if mark.type == 'Point'
				M.appendGoogleMarker(mark)
			if mark.type == 'Circle'
				M.appendGoogleCircle(mark)
	## ## ##
	appendYandexMarker: (mark) ->
		M = @
		marker = new yandex.Placemark(
			mark.coords,
			{'iconCaption': M.params.title,'balloonContent': mark.content},
			{'iconLayout': 'default#image','iconImageHref': M.params.icon,'iconImageSize': [40, 49],'iconImageOffset': [-20, -49]}
		)
		M.map.geoObjects.add(marker)
	appendYandexCircle: (mark) ->
		M = @
		circle = new yandex.Circle(
			[mark.coords,mark.circle_size],
			{balloonContent: mark.content},
			{draggable: false,fillColor: "#de3b3c59",strokeColor: "#de3b3c",strokeOpacity: 0.8,strokeWidth: 2}
		)
		M.map.geoObjects.add(circle)
	## ## ##
	appendGoogleMarker: (mark) ->
		M = @
		marker = new google.maps.Marker(
			map: M.map
			position: {'lat':parseFloat(mark.coords[0]), 'lng':parseFloat(mark.coords[1]) }
			title: M.params.title
			icon: M.params.icon
		)
		if mark.content != ''
			infoWindow = new google.maps.InfoWindow({content: mark.content})
			marker.addListener 'click', () ->
				infoWindow.open(M.map, marker)
	appendGoogleCircle: (mark) ->
		M = @
		circle = new google.maps.Circle(
			map: M.map
			center: {'lat':parseFloat(mark.coords[0]), 'lng':parseFloat(mark.coords[1]) }
			radius: mark.circle_size
			strokeColor: '#de3b3c'
			strokeWeight: 2
			strokeOpacity: 0.8
			fillColor: '#de3b3c'
			fillOpacity: 0.35
		)
		if mark.content != ''
			infoWindow = new google.maps.InfoWindow({content: mark.content})
			circle.addListener 'click', () ->
				infoWindow.open(M.map, circle)
	## ## ##
	fullSizeYandex: () ->
		if @map_container.hasClass('full')
			@map_container.removeClass('full')
			@map.behaviors.disable('scrollZoom')
			$('#wpadminbar').show()
		else
			@map_container.addClass('full')
			@map.behaviors.enable('scrollZoom')
			$('#wpadminbar').hide()
		@map.container.fitToViewport()

$(document).ready () ->
	window.jsmap = new Map()